import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import httpService from "services/httpService.js";
import * as constants from "Constants";
import log from "loglevel";
import OtherActivity from "Screens_old/OtherLab/student/index";
import displayGlobalMessage from "Utils/DisplayGlobalMessage.js";

const OtherLabsIframe = () => {
    const { activityID } = useParams();
    const [searchParams] = useSearchParams();

    // 1. State for Data
    const [activityDetails, setActivityDetails] = useState(null);
    const [labData, setLabData] = useState(null);
    const [studentData, setStudentData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchIframeData = async () => {
            try {
                setLoading(true);

                // A. Fetch Activity Details
                const activityUrl = `${constants.base_url}/lab/activity/${activityID}?type=other`;
                const activityRes = await httpService.get(activityUrl);
                const activityData = activityRes.data?.other_activity;

                setActivityDetails(activityData);

                // B. Fetch Lab Context (We need the lab_id from the activity to get exam settings)
                // Note: Ensure your API returns 'lab_id' in the activity response. 
                // If not, you might need to adjust this logic.
                if (activityData && activityData.lab_id) {
                    const labId = activityData.lab_id;

                    // Fetch Lab Settings (for timer/duration)
                    const labUrl = `${constants.base_url}/lab/all/${labId}`;
                    const labRes = await httpService.get(labUrl);
                    setLabData(labRes.data.lab);

                    // Fetch Student Exam Status (if applicable)
                    const studentUrl = `${constants.base_url}/exam/student/${labId}`;
                    const studentRes = await httpService.get(studentUrl);
                    setStudentData(studentRes.data.student_exam);
                }

            } catch (error) {
                log.error("Iframe Fetch Error:", error);
                displayGlobalMessage("Error loading activity", "error");
            } finally {
                setLoading(false);
            }
        };

        if (activityID) {
            fetchIframeData();
        }
    }, [activityID]);

    const handleTimeUp = () => {
        console.log("Time up in Iframe");
        displayGlobalMessage("Time is up!", "warning");
    };

    const handleLabTimeUp = () => {
        console.log("Lab Time up in Iframe");
    };

    if (loading) return <div className="p-5 text-center">Loading Activity...</div>;

    return (
        <div className="iframe-activity-container">
            {activityDetails ? (
                <OtherActivity
                    otherActivityDetails={activityDetails}
                    labAvailableTill={labData?.available_till}
                    labId={labData?.id}
                    isExam={labData?.is_exam}
                    studentData={studentData}
                    handleTimeUp={handleTimeUp}
                    handleLabTimeUp={handleLabTimeUp}
                />
            ) : (
                <div>Activity not found</div>
            )}
        </div>
    );
};

export default OtherLabsIframe;